import styled from 'styled-components';

export const MobilePositionParamEditorStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;

    .form-label {
        margin: 0;
        padding: 12px 0;
        color: rgba(255, 255, 255, 0.6);

        &[role=button] {
            color: rgba(255, 255, 255, 1);
        }
    }

    .editable {
        display: inline;
        color: var(--color-white);
        font-weight: 700;

        &:focus {
            outline: none;
        }
    }
`;

export const MobilePositionParamEditorErrorStyled = styled.div`
    color: var(--color-red);
    font-size: 14px;
    font-weight: 400;
`;